webpackJsonp([202],{

/***/ 1153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "Vue 应用中使用微信 jssdk | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1968:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1153),
  /* template */
  __webpack_require__(2200),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/vue-wechat-jssdk-315.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] vue-wechat-jssdk-315.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-45639e23", Component.options)
  } else {
    hotAPI.reload("data-v-45639e23", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2200:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Vue 应用中使用微信 jssdk")]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("分享接口只有认证公众号才能使用，域名必须备案且在微信后台设置。")]), _vm._v(" "), _c('p', [_vm._v("先确认已经满足使用"), _c('code', [_vm._v("jssdk")]), _vm._v("的要求再进行开发。")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("WechatPlugin")]), _vm._v(" 插件提供了"), _c('code', [_vm._v("commonJS")]), _vm._v("的引入方式，因此你不需要在 "), _c('code', [_vm._v("index.html")]), _vm._v(" 引入文件。")]), _vm._v(" "), _c('h2', [_vm._v("版本要求")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("WechatPlugin")]), _vm._v("在"), _c('code', [_vm._v("vux@^2.1.0-rc.19")]), _vm._v("开始支持")]), _vm._v(" "), _c('h2', [_vm._v("引入")]), _vm._v(" "), _c('p', [_vm._v("在 "), _c('code', [_vm._v("main.js")]), _vm._v(" 中全局引入：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { WechatPlugin } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\nVue.use(WechatPlugin)\n\n"), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("console")]), _vm._v(".log(Vue.wechat) "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 可以直接访问 wx 对象。")]), _vm._v("\n")])]), _vm._v(" "), _c('h2', [_vm._v("组件外使用")]), _vm._v(" "), _c('p', [_vm._v("考虑到你需要在引入插件后调用"), _c('code', [_vm._v("config")]), _vm._v("方法进行配置，你可以通过 "), _c('code', [_vm._v("Vue.wechat")]), _vm._v(" 在组件外部访问"), _c('code', [_vm._v("wx")]), _vm._v("对象。")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("jssdk")]), _vm._v("需要请求签名配置接口，你可以直接使用 VUX 基于 "), _c('code', [_vm._v("Axios")]), _vm._v(" 封装的 "), _c('code', [_vm._v("AjaxPlugin")]), _vm._v("。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { WechatPlugin, AjaxPlugin } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\nVue.use(WechatPlugin)\nVue.use(AjaxPlugin)\n\nVue.http.get("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'/api'")]), _vm._v(", ({data}) => {\n  Vue.wechat.config(data.data)\n})\n")])]), _vm._v(" "), _c('h2', [_vm._v("组件中使用")]), _vm._v(" "), _c('p', [_vm._v("那么之后任何组件中都可以通过 "), _c('code', [_vm._v("this.$wechat")]), _vm._v(" 访问到 "), _c('code', [_vm._v("wx")]), _vm._v(" 对象。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n  created () {\n    "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$wechat.onMenuShareTimeline({\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'hello VUX'")]), _vm._v("\n    })\n  }\n}\n")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-45639e23", module.exports)
  }
}

/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1968);

/***/ })

});


// WEBPACK FOOTER //
// 202.8088fd21.js